import { createRequest, RequestConfig } from 'app/common/api';

import { TRole } from '../core/role';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_role',
};

export const getRoleRequest = (id: TRole['id']) =>
  createRequest({
    url: config.url,
    method: config.method,
    query: {
      id: String(id),
    },
  });
